import { ActionMetaInfo, AppContext } from 'mini-app-context';
import { executeDiagnosticsTask } from 'mini-diagnostics/lib/utils/executeDiagnosticsTask';
import { getDataLogger } from 'telemetry';
import { logDiagnostics } from 'mini-diagnostics-common/lib/workflow/actions/logDiagnostics';

/**
 * Listener to log the app signals
 */
export function logListener(metaInfo: ActionMetaInfo, ctx: AppContext) {
    const logger = getDataLogger();
    const { name, actionSource, customData, options } = metaInfo;

    logger(name, { ...customData, cId: ctx.cId }, { actionSource, ...options });

    // Log for diagnostics
    executeDiagnosticsTask(() => logDiagnostics({ name, customData, cId: ctx.cId }));
}
